import { usePostHog } from 'posthog-js/react';
import { ReactNode, useEffect, useState } from 'react';

interface PosthogLoadingWrapperProps {
  children: ReactNode;
}

export function PosthogLoadingWrapper({ children }: PosthogLoadingWrapperProps) {
  const posthog = usePostHog();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    posthog.onFeatureFlags(() => {
      setIsLoaded(true);
    });
  }, [posthog]);

  if (!isLoaded) {
    return null;
  }

  return <>{children}</>;
}
